import React, { useEffect } from "react";

import FooterTop from "./FooterTop";
import FooterMiddle from "./FooterMiddle";
import FooterBottom from "./FooterBottom";
import FooterOurRecognitions from "./FooterOurRecognition";

const Footer = () => {
  useEffect(() => {
    console.clear();
  }, []);
  return (
    <footer style={{ background: "#f6fbfd" }}>
      <div className="footer-section">
        <div className="container">
          <div className="row">
            <FooterTop />
            <FooterMiddle />
            <FooterOurRecognitions />
            <FooterBottom />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
